export const SORT_OPTIONS = [
  { key: 'default', label: 'Recommended' },
  { key: 'price', label: 'Lowest price' },
  { key: 'rating', label: 'Highest rating' },
  { key: 'dispatch', label: 'Fastest delivery' },
  { key: 'nearest', label: 'Nearest location' },
];

export function sortCatalogListings(listings, sortKey = 'default') {
  const available = listings.filter((l) => l.available !== false);
  const unavailable = listings.filter((l) => l.available === false);
  const sorted = [...available];

  switch (sortKey) {
    case 'price':
      sorted.sort((a, b) => (a.price || 0) - (b.price || 0));
      break;
    case 'rating':
      sorted.sort((a, b) => {
        const ar = Number.isFinite(Number(a.sellerRating)) ? Number(a.sellerRating) : 0;
        const br = Number.isFinite(Number(b.sellerRating)) ? Number(b.sellerRating) : 0;
        return br - ar || (a.price || 0) - (b.price || 0);
      });
      break;
    case 'dispatch':
      sorted.sort(
        (a, b) =>
          (a.dispatchWindowHours || 48) - (b.dispatchWindowHours || 48) ||
          (a.price || 0) - (b.price || 0)
      );
      break;
    case 'nearest':
      sorted.sort((a, b) => {
        const ad = a.distanceKm;
        const bd = b.distanceKm;
        if (ad == null && bd == null) return (a.price || 0) - (b.price || 0);
        if (ad == null) return 1;
        if (bd == null) return -1;
        return ad - bd || (a.price || 0) - (b.price || 0);
      });
      break;
    case 'default':
    default:
      sorted.sort(
        (a, b) =>
          (b.rankScore || 0) - (a.rankScore || 0) ||
          (a.price || 0) - (b.price || 0)
      );
      break;
  }

  return [...sorted, ...unavailable];
}
